import { render, staticRenderFns } from "./simKefu.vue?vue&type=template&id=f5319b60&scoped=true&"
import script from "./simKefu.vue?vue&type=script&lang=js&"
export * from "./simKefu.vue?vue&type=script&lang=js&"
import style0 from "./simKefu.vue?vue&type=style&index=0&id=f5319b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5319b60",
  null
  
)

export default component.exports